import type { RateCurrency, RateHistoryEntry } from '../../shared/api/exchangeRates.api'

export const CURRENCY_LABEL: Record<RateCurrency, string> = {
  USD: '$ Доллар',
  EUR: '€ Евро',
  CNY: '¥ Юань',
}
export const CURRENCIES: RateCurrency[] = ['USD', 'EUR', 'CNY']

export function formatDateTime(iso: string): string {
  return new Date(iso).toLocaleString('ru-RU', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}

export function formatRate(n: number): string {
  return n.toLocaleString('ru-RU', { maximumFractionDigits: 4 }) + ' ₽'
}

function delta(entry: RateHistoryEntry): number | null {
  return entry.prevRate === null ? null : Math.round((entry.rate - entry.prevRate) * 1e4) / 1e4
}

function authorText(entry: RateHistoryEntry): string {
  return entry.setBy ? entry.setBy.name || entry.setBy.email : '—'
}

/**
 * Таблица изменений курса: дата и время, валюта, новый курс, разница к прошлому
 * значению этой валюты, кто поставил. Общая для «последних», архива и поиска по дате.
 */
export function RateHistoryTable({ rows, label }: { rows: RateHistoryEntry[]; label: string }) {
  return (
    <div className="table-base overflow-x-auto">
      <table className="text-sm" aria-label={label}>
        <thead>
          <tr>
            <th className="px-4 py-2">Дата и время</th>
            <th className="px-4 py-2">Валюта</th>
            <th className="px-4 py-2 text-right">Был</th>
            <th className="px-4 py-2 text-right">Стал</th>
            <th className="px-4 py-2 text-right">Изменение</th>
            <th className="px-4 py-2">Кто</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => {
            const d = delta(r)
            return (
              <tr key={r.id} className="border-t border-gray-100">
                <td className="px-4 py-2 whitespace-nowrap">{formatDateTime(r.setAt)}</td>
                <td className="px-4 py-2 whitespace-nowrap">{CURRENCY_LABEL[r.currency]}</td>
                <td className="px-4 py-2 text-right tabular-nums whitespace-nowrap text-gray-500">
                  {r.prevRate === null ? '—' : formatRate(r.prevRate)}
                </td>
                <td className="px-4 py-2 text-right tabular-nums whitespace-nowrap">
                  {formatRate(r.rate)}
                </td>
                <td
                  className={`px-4 py-2 text-right tabular-nums whitespace-nowrap ${
                    d === null || d === 0
                      ? 'text-gray-400'
                      : d > 0
                        ? 'text-red-600'
                        : 'text-green-600'
                  }`}
                >
                  {d === null
                    ? '—'
                    : `${d > 0 ? '+' : ''}${d.toLocaleString('ru-RU', { maximumFractionDigits: 4 })}`}
                </td>
                <td
                  className="px-4 py-2 text-gray-600"
                  title={
                    r.setBy
                      ? r.setBy.email
                      : 'Автор не записан: начальная запись истории или удалённый пользователь'
                  }
                >
                  {authorText(r)}
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}
